
import ProductCTA from "@/components/ProductCTA";

interface ArticleContentProps {
  content: string;
}

const ArticleContent = ({ content }: ArticleContentProps) => {
  return (
    <article className="prose prose-lg max-w-none 
      prose-p:leading-relaxed prose-p:mb-12 prose-p:text-lg
      prose-headings:mt-20 prose-headings:mb-12
      prose-h2:text-3xl prose-h2:font-bold prose-h2:tracking-tight
      prose-h3:text-2xl prose-h3:font-semibold
      prose-img:rounded-xl prose-img:my-20 prose-img:shadow-lg
      prose-a:text-primary prose-a:no-underline hover:prose-a:underline 
      prose-blockquote:border-l-primary prose-blockquote:bg-primary/5 prose-blockquote:p-8 prose-blockquote:rounded-r-md prose-blockquote:my-16
      prose-ul:my-12 prose-ol:my-12 
      prose-li:mb-6 prose-li:text-lg prose-li:marker:text-primary
      prose-li:pl-2 prose-ul:space-y-4 prose-ol:space-y-4">
      <div dangerouslySetInnerHTML={{ __html: content || '' }} />
      
      {/* Inline CTA midway through content */}
      <div className="my-16">
        <ProductCTA variant="inline" message="Having armpit issues? Try our natural deodorant solution!" />
      </div>
      
      {/* Bottom of article keyword section */}
      <div className="mt-16 p-6 bg-sage-50 rounded-xl">
        <h4 className="text-xl font-semibold mb-4">Related Topics You Might Be Interested In:</h4>
        <div className="flex flex-wrap gap-3">
          <a href="https://itjustworksdeodorant.com?sca_ref=8468108.vEEWUNzhD1" target="_blank" rel="noopener noreferrer" className="px-3 py-2 bg-white hover:bg-primary/10 text-sm rounded-full transition-colors">
            best deodorant for athletes
          </a>
          <a href="https://murphyandmcneil.com/products/grooming-lounge-greatest-pits-deodorant?sca_ref=8468498.oO9QXbgAQO" target="_blank" rel="noopener noreferrer" className="px-3 py-2 bg-white hover:bg-primary/10 text-sm rounded-full transition-colors">
            long-lasting deodorant for men
          </a>
          <a href="https://www.kinko.care/?ref=rlexraps" target="_blank" rel="noopener noreferrer" className="px-3 py-2 bg-white hover:bg-primary/10 text-sm rounded-full transition-colors">
            organic deodorant for women
          </a>
          <a href="https://itjustworksdeodorant.com?sca_ref=8468108.vEEWUNzhD1" target="_blank" rel="noopener noreferrer" className="px-3 py-2 bg-white hover:bg-primary/10 text-sm rounded-full transition-colors">
            best deodorant for controlling sweat
          </a>
          <a href="https://www.kinko.care/?ref=rlexraps" target="_blank" rel="noopener noreferrer" className="px-3 py-2 bg-white hover:bg-primary/10 text-sm rounded-full transition-colors">
            how to choose the right deodorant for sensitive skin
          </a>
        </div>
      </div>
    </article>
  );
};

export default ArticleContent;
